import Storage from 'services/storage'

const storage = new Storage('page_analytics')

export const retrivePageType = () => storage.get('page_type')

export const storePageType = (type) => storage.set('page_type', type)
